export default "__VITE_ASSET__CIRWcRfv__"